import { TranslateFn } from '../../../hooks/context/useTranslate';
import { FilterError } from '../../../types/types';
import { DecimalPlacesIssue, ExportColumnRoundingMode } from '../types';
import resolveDecimalPlacesIssue from './resolveDecimalPlacesIssue';

const DECIMAL_PLACES_ERROR_KEYS: Record<DecimalPlacesIssue, string> = {
  notANumber: 'export.decimalPlacesNotANumber',
  invalid: 'export.decimalPlacesInvalid',
  outOfRange: 'export.decimalPlacesMax',
};

const resolveDecimalPlacesError = (
  decimalPlaces: string,
  roundingMode: ExportColumnRoundingMode,
  t: TranslateFn
): FilterError => {
  const issue = resolveDecimalPlacesIssue(decimalPlaces, roundingMode);

  if (issue === null) {
    return null;
  }

  return [t(DECIMAL_PLACES_ERROR_KEYS[issue])];
};

export default resolveDecimalPlacesError;
